// Web replacement for react-native-ultimate-config: values come from .env.<mode> via Vite.
const Config = {
  API_BASE_URL: import.meta.env.API_BASE_URL as string | undefined,
  ENVIRONMENT: import.meta.env.ENVIRONMENT as string | undefined,
  FIREBASE_PROJECT_ID: import.meta.env.FIREBASE_PROJECT_ID as string | undefined,
};

export default Config;
